import { render, staticRenderFns } from "./allViewComments.vue?vue&type=template&id=7372a1c8&scoped=true&"
import script from "./allViewComments.vue?vue&type=script&lang=js&"
export * from "./allViewComments.vue?vue&type=script&lang=js&"
import style0 from "./allViewComments.vue?vue&type=style&index=0&id=7372a1c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7372a1c8",
  null
  
)

export default component.exports